import { Card as MuiCard } from '@mui/material';
import styled from 'styled-components';

export const Card = styled(MuiCard)`
  border: none;
`;
